import api from "../../utils/ApiConfig";

export const fetchPricingSettings = async () => {
  const response = await api.get("/bo/pricing-settings");
  return response.data; // { success, settings: { poids: [...], temps: [...], livraison: [...] } }
};

export const bulkUpdatePricingSettings = async (settings) => {
  const response = await api.put("/bo/pricing-settings/bulk", { settings });
  return response.data;
};
